import { css } from 'emotion';
import {
	grey,
	pink,
	mobileMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const wrapperStyle = css({
	height: '100px',
	background: '#F6F6F6',
	position: 'relative',
	[`@media(max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		height: 'auto',
	},
});

export const logoAndBackStyle = back =>
	css({
		display: 'flex',
		alignItems: 'center',
		position: 'relative',
		...(back
			? {
					[`& .${backArrowStyle}`]: {
						position: 'absolute',
						left: '-44px',
					},
					[`@media screen and (max-width: ${desktopMaxWidthBreakpoint + 64}px)`]: {
						[`& .${backArrowStyle}`]: {
							position: 'relative',
							left: '0',
							marginRight: '20px',
						},
					},
			  }
			: null),
		[`@media(max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			padding: '10px 0',
		},
	});

export const backArrowStyle = css({
	'& svg': {
		transform: 'rotate(180deg)',
	},
	'@media print': {
		display: 'none',
	},
});

export const subheaderStyle = css({
	color: grey,
	fontSize: '10px',
	fontWeight: 'bold',
	padding: '0 0 0 20px',
	textDecoration: 'none',
	textTransform: 'uppercase',
});

export const logoLinkStyle = css({});

const baseHeaderStyle = {
	display: 'flex',
	alignItems: 'center',
};

export const headerStyle = css(baseHeaderStyle);

export const ctaStyle = css({
	color: grey,
	fontSize: '14px',
	lineHeight: '17px',
	display: 'flex',
	alignItems: 'center',
	'& p': {
		margin: '0 24px 0 0',
	},
	'& a': {
		fontWeight: 'bold',
		color: pink,
		fontSize: '14px',
		lineHeight: '17px',
		textDecoration: 'none',
		'& svg': {
			marginLeft: '10px',
		},
	},
	[`@media(max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		padding: '10px 0',
		justifyContent: 'flex-start',
	},
	[`@media(max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		'& p, & a': {
			fontSize: '10px',
			lineHeight: '12px',
		},
		'& p': {
			maxWidth: '130px',
			marginRight: '12px',
		},
	},
	'@media print': {
		display: 'none',
	},
});

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	margin: '0 auto',
	padding: '0 20px',
	height: '100%',
	display: 'flex',
	justifyContent: 'space-between',
	[`@media screen and (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		justifyContent: 'flex-start',
		flexDirection: 'column',
	},
	[`@media(max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		padding: '0 10px',
	},
});

export const logoStyle = css({
	'& #logoDesktop': {
		width: '158px',
		height: '54px',
	},
	'& #logoMobile': {
		display: 'none',
		height: '37px',
		width: '28px',
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		'& #logoDesktop': {
			display: 'none',
		},
		'& #logoMobile': {
			display: 'block',
		},
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/headerSimple/headersimple.styles.js